import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, HttpInterceptorFn } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { importProvidersFrom, inject } from '@angular/core';

import { routes } from './app.routes';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AuthService } from './services/auth.service';
import { CompanyContextService } from './services/company-context.service';

// Crear interceptor funcional para Auth
const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const companyContextService = inject(CompanyContextService);

  const token = authService.getToken();
  const currentUser = authService.getCurrentUser();

  const headers: any = {};

  // Always skip ngrok-free interstitial when API is tunneled.
  headers['ngrok-skip-browser-warning'] = 'true';

  // Add Authorization header
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add X-Company-Id header for God users when impersonating
  if (currentUser?.role === 'god') {
    const companyId = companyContextService.getCurrentCompanyId();
    if (companyId) {
      headers['X-Company-Id'] = companyId;
    }
  }

  // Clone request with headers
  if (Object.keys(headers).length > 0) {
    req = req.clone({ setHeaders: headers });
  }

  return next(req);
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        // Reinicia scroll al top en cada NavigationEnd y restaura la posicion
        // anterior al usar el boton "atras" del browser.
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'es'
      })
    )
  ]
};
